function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Camera"
}, /*#__PURE__*/React.createElement("title", null, "VF_camera_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M177.2 226.8v-78h92.1V28.3H7.7l10.9 28.3H0v63.8h43.1L54 148.8h94.8v106.3h134.7v-28.4H177.2zM49 56.7h192v63.8H73.5L49 56.7z"
}))));